import {
    RECEIVING_WORKPERIODS,
    RECEIVED_WORKPERIODS,
    FAILURE_WORKPERIODS,
    CLEAR_WORKPERIODS,
    RECEIVING_WORKPERIOD_DETAIL,
    RECEIVED_WORKPERIOD_DETAIL,
    FAILURE_WORKPERIOD_DETAIL,
    CLEAR_WORKPERIOD_DETAIL,
    RECEIVING_WORKPERIOD_USERS,
    RECEIVED_WORKPERIOD_USERS,
    FAILURE_WORKPERIOD_USERS,
    ENDING_WORKPERIOD,
    ENDED_WORKPERIOD,
    FAILURE_END_WORKPERIOD,
    STARTING_WORKPERIOD,
    STARTED_WORKPERIOD,
    FAILURE_START_WORKPERIOD,
    DOWNLOADING_WORKPERIOD_CLOSEOUT,
    DOWNLOADED_WORKPERIOD_CLOSEOUT,
    FAILURE_WORKPERIOD_CLOSEOUT,
} from '../actions/sales';

const defaultState = {
    workperiods: [],
    workperiodsLoading: false,
    workperiodDetail: null,
    workperiodDetailLoading: false,
    workperiodUsers: [],
    workperiodUsersLoading: false,
    workperiodToggling: false,
    workperiodCloseoutDownloading: false,
    error: null,
};

export default function salesReducer(state = defaultState, action) {
    switch (action.type) {
        case RECEIVING_WORKPERIODS:
            return {
                ...state,
                workperiodsLoading: true,
                error: null,
            };
        case RECEIVED_WORKPERIODS:
            return {
                ...state,
                workperiods: action.payload || [],
                workperiodsLoading: false,
                error: null,
            };
        case FAILURE_WORKPERIODS:
            return {
                ...state,
                workperiodsLoading: false,
                error: action.payload || 'Failed to load work periods',
            };
        case CLEAR_WORKPERIODS:
            return {
                ...state,
                workperiods: [],
                workperiodsLoading: false,
                error: null,
            };
        case RECEIVING_WORKPERIOD_DETAIL:
            return {
                ...state,
                workperiodDetailLoading: true,
                error: null,
            };
        case RECEIVED_WORKPERIOD_DETAIL:
            return {
                ...state,
                workperiodDetail: action.payload,
                workperiodDetailLoading: false,
                error: null,
            };
        case FAILURE_WORKPERIOD_DETAIL:
            return {
                ...state,
                workperiodDetailLoading: false,
                error: action.payload || 'Failed to load work period detail',
            };
        case CLEAR_WORKPERIOD_DETAIL:
            return {
                ...state,
                workperiodDetail: null,
                workperiodDetailLoading: false,
                workperiodUsers: [],
                workperiodUsersLoading: false,
                workperiodCloseoutDownloading: false,
                error: null,
            };
        case RECEIVING_WORKPERIOD_USERS:
            return {
                ...state,
                workperiodUsersLoading: true,
            };
        case RECEIVED_WORKPERIOD_USERS:
            return {
                ...state,
                workperiodUsers: action.payload || [],
                workperiodUsersLoading: false,
            };
        case FAILURE_WORKPERIOD_USERS:
            return {
                ...state,
                workperiodUsersLoading: false,
                error: action.payload || 'Failed to load work period users',
            };
        case ENDING_WORKPERIOD:
        case STARTING_WORKPERIOD:
            return {
                ...state,
                workperiodToggling: true,
                error: null,
            };
        case ENDED_WORKPERIOD:
        case STARTED_WORKPERIOD:
            return {
                ...state,
                workperiodToggling: false,
                error: null,
            };
        case FAILURE_END_WORKPERIOD:
        case FAILURE_START_WORKPERIOD:
            return {
                ...state,
                workperiodToggling: false,
                error: action.payload || 'Failed to toggle work period',
            };
        case DOWNLOADING_WORKPERIOD_CLOSEOUT:
            return {
                ...state,
                workperiodCloseoutDownloading: true,
                error: null,
            };
        case DOWNLOADED_WORKPERIOD_CLOSEOUT:
            return {
                ...state,
                workperiodCloseoutDownloading: false,
                error: null,
            };
        case FAILURE_WORKPERIOD_CLOSEOUT:
            return {
                ...state,
                workperiodCloseoutDownloading: false,
                error: action.payload || 'Failed to download closeout summary',
            };
        default:
            return state;
    }
}
